import { Route, Routes, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import MainLayout from './layouts/MainLayout';
import Home from './views/Home';
import Projects from './views/Projects';
import ProjectDetails from './views/ProjectDetails';
import About from './views/About';
import CloudInfra from './views/CloudInfra';
import AIAgents from './views/AIAgents';
import Automations from './views/Automations';
import Analytics from './views/Analytics';
import Contact from './views/Contact';
import PrivacyPolicy from './views/PrivacyPolicy';
import TermsOfService from './views/TermsOfService';
import CookiePolicy from './views/CookiePolicy';

function App() {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<MainLayout />}>
          <Route index element={<Home />} />
          <Route path="cloud-infra" element={<CloudInfra />} />
          <Route path="ai-agents" element={<AIAgents />} />
          <Route path="automations" element={<Automations />} />
          <Route path="analytics" element={<Analytics />} />
          <Route path="projects" element={<Projects />} />
          <Route path="projects/:id" element={<ProjectDetails />} />
          <Route path="about" element={<About />} />
          <Route path="contact" element={<Contact />} />
          <Route path="privacy-policy" element={<PrivacyPolicy />} />
          <Route path="terms-of-service" element={<TermsOfService />} />
          <Route path="cookie-policy" element={<CookiePolicy />} />
        </Route>
      </Routes>
    </AnimatePresence>
  );
}

export default App;
